import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CommonsService } from 'src/app/services/commons.service';
@Component({
  standalone: false,
  selector: 'app-global-position',
  templateUrl: './global-position.component.html',
  styleUrls: ['./global-position.component.scss']
})
export class GlobalPositionComponent implements OnInit {
  constructor(private readonly r: Router, private readonly c: CommonsService) { }

  ngOnInit() {
    this.c.reloadOTBanner();
    this.c.clearDup();
    if (!sessionStorage.getItem('_k')) {
      this.r.navigateByUrl('terms');
    }
  }
}
